import { render, staticRenderFns } from "./createFolder.vue?vue&type=template&id=59cdcea5&scoped=true"
import script from "./createFolder.vue?vue&type=script&lang=js"
export * from "./createFolder.vue?vue&type=script&lang=js"
import style0 from "./createFolder.vue?vue&type=style&index=0&id=59cdcea5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cdcea5",
  null
  
)

export default component.exports